import React from "react";
import HeadersPresenter from "./HeadersPresenter";

const HeadersContainer = () => {
  return <HeadersPresenter />;
};

export default HeadersContainer;
